import React from 'react';
import { YoutubeShortsBlockType } from '@appTypes/YoutubeShortsBlockType';
import { ShortsCarousel } from '@components/ShortsCarousel/ShortsCarousel';

interface ShortsCarouselSerializerProps {
  value: YoutubeShortsBlockType;
}

export const ShortsCarouselBlock = ({ value }: ShortsCarouselSerializerProps) => (
  <ShortsCarousel videos={value.videos} title={value.title} background={value.background} />
);
